'use client'

import { AlertIcon } from './Icons'
import { useCallback } from 'react'
import { useConfirmationModal } from './state'
import { cn } from '~/utils/cn'
import { useTranslation } from '~/i18n/useTranslation'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '~/components/Dialog'

export const ConfirmationModal = () => {
  const { t } = useTranslation()
  const {
    title,
    description,
    confirmButtonCaption,
    color,
    isOpen,
    close,
    onConfirm,
  } = useConfirmationModal()

  const handleSave = useCallback(() => {
    onConfirm()
    close()
  }, [onConfirm, close])

  const handleOpenChange = useCallback((isOpen: boolean) => {
    if (!isOpen) {
      close()
    }
  }, [])

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="pt-10 px-0 pb-0 w-[37.5rem]" placement="center">
        <DialogHeader className="flex gap-4 items-center px-10">
          <div
            className={cn('rounded-xl p-4 bg-opacity-10', {
              'bg-primary-500 text-primary-500': color === 'primary',
              'bg-[#EB5757] text-[#EB5757]': color === 'red',
              'bg-orange-500 text-orange-500': color === 'orange',
            })}
          >
            <AlertIcon className="w-6" />
          </div>
          <DialogTitle className="text-black text-lg font-medium">
            {title}
          </DialogTitle>
        </DialogHeader>
        <section className="flex flex-col h-full">
          <DialogDescription className="my-6 px-10 max-h-[40vh] overflow-auto">
            {description}
          </DialogDescription>
          <footer className="flex sm:flex-row flex-col justify-end items-stretch sm:items-center gap-3 sm:gap-4 mt-auto px-10 py-7">
            <DialogClose asChild>
              <button className="px-7 py-3 rounded-xl border-2 border-[#707070] text-[#707070] hover:border-gray-400 hover:text-gray-400 transition-colors font-semibold text-sm cursor-pointer">
                {t('action.cancel')}
              </button>
            </DialogClose>
            <button
              className={cn(
                'px-7 py-[0.8rem] rounded-xl text-white  transition-colors font-semibold text-sm cursor-pointer',
                {
                  'bg-primary-500 hover:bg-blue-500': color === 'primary',
                  'bg-[#EB5757] hover:bg-red-400': color === 'red',
                  'bg-orange-500 hover:bg-orange-600': color === 'orange',
                }
              )}
              onClick={handleSave}
            >
              {confirmButtonCaption}
            </button>
          </footer>
        </section>
      </DialogContent>
    </Dialog>
  )
}
